import React from 'react';
import { Box } from '@material-ui/core';
import { useQuery, useResponsiveBreakpoint } from '../../hooks';

function ErrorPage() {
    const message = useQuery().get('message');
    const isXs = useResponsiveBreakpoint('xs');

    return (
        <Box height="100vh" width="100vw" display="flex" justifyContent="center" alignItems="center">
            <Box left={isXs ? '32px' : '85px'} top={isXs ? '24px' : '64px'} position="absolute">
                <img src="/images/logo.png" height="25" />
            </Box>

            <Box textAlign="center" py={2}>
                <Box>
                    <img src="/images/404.gif" width="273" />
                </Box>
                {/* 48 */}
                <Box fontSize={isXs ? 'h4.fontSize' : 'h3.fontSize'}>Hrm...</Box>
                {/* 32 */}
                <Box fontSize={isXs ? 'h5.fontSize' : 'h4.fontSize'}>{message || 'Something went wrong.'}</Box>
                {/* 24 */}
                <Box fontSize={isXs ? 'h6.fontSize' : 'h5.fontSize'}>
                    For additional help, please contact us at:<br/>
                    <a href="mailto:support@listreports.com" target="_blank"><strong>support@listreports.com</strong></a><br/>
                </Box>
            </Box>
        </Box>
    );
}

export default ErrorPage;
